/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportresolved2Inputs */

const en_contentreportresolved2 = /** @type {(inputs: Contentreportresolved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report resolved`)
};

const de_contentreportresolved2 = /** @type {(inputs: Contentreportresolved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung erledigt`)
};

/**
* | output |
* | --- |
* | "Report resolved" |
*
* @param {Contentreportresolved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportresolved2 = /** @type {((inputs?: Contentreportresolved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportresolved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportresolved2(inputs)
	return de_contentreportresolved2(inputs)
});
export { contentreportresolved2 as "contentReportResolved" }